import React from 'react';
import Spinner from 'react-spinkit';

import Title from '../../components/Title';

const WaitingListBook = () => (
  <div className="u-text-center u-pt++">
    <Title>Book appointment</Title>
    Booking appointment...
    <Spinner className="u-co-teal-blue u-mt-" noFadeIn />
  </div>
);

export default WaitingListBook;



// WEBPACK FOOTER //
// ./src/app/confirmation/components/WaitingListBook.jsx